var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-action-sheet',{attrs:{"actions":_vm.actions,"close-on-click-overlay":false},on:{"select":_vm.onSelect,"click-overlay":_vm.close},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }